import {
  keepPreviousData,
  type QueryFunctionContext,
  skipToken,
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';
import { type AxiosResponse } from 'axios';

import { api } from '@/api';
import { END_POINT } from '@/constants/end-point.constants';
import { ORGANIZATION_ACCOUNTS_QUERY_KEYS } from '@/constants/query-keys.constants';
import type { AccountsResponse } from '@/features/account/types';

const fetchOrganizationAccounts = ({
  queryKey: [{ filters, id }],
}: QueryFunctionContext<
  ReturnType<(typeof ORGANIZATION_ACCOUNTS_QUERY_KEYS)['list']>
>): Promise<AxiosResponse<AccountsResponse>> =>
  api.get(END_POINT.organizationAccounts(id!), { params: filters });

export const useOrganizationAccounts = (
  id: string,
  filters?: unknown,
  useQueryOptions?: Partial<UseQueryOptions>,
) => {
  const { enabled = true } = useQueryOptions ?? {};

  return useQuery({
    queryKey: ORGANIZATION_ACCOUNTS_QUERY_KEYS.list(filters, id),
    queryFn: enabled ? fetchOrganizationAccounts : skipToken,
    placeholderData: keepPreviousData,
    select: data => data.data,
  });
};
